import { render, staticRenderFns } from "./LangSection.vue?vue&type=template&id=2f1b457a"
import script from "./LangSection.vue?vue&type=script&lang=js"
export * from "./LangSection.vue?vue&type=script&lang=js"
import style0 from "./LangSection.vue?vue&type=style&index=0&id=2f1b457a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports